import { useState } from "react"
import { EnkInputField } from "../components/inputs/inputfield"
import { EnkInput } from "../components/inputs/input"
import { EnkPrimaryButton } from "../components/common/buttons"
import { EnkIWPServerAuth } from "../api/api-iwp-server"
import EnkIwpLogo from "../components/iwp-logo"
import { EnkHeader } from "../components/text/header"
import { useMsgDialog } from "../dialogs/use-msgdialog"
import { EnkApiError } from "../api/do-request"

export default function ResetPasswordPage() {
  const queryParams = new URLSearchParams(location.search)
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")
  const { messageDialog } = useMsgDialog()

  const code = queryParams.get("code") || ""

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (!code) {
      messageDialog("error", "Geen resetcode opgegeven in de url! Gebruik de link uit de wachtwoord-reset email.", ["OK"], () => {})
      return
    }

    if (newPassword !== confirmPassword) {
      setError("Wachtwoorden komen niet overeen.")
      return
    }

    EnkIWPServerAuth.passwordReset(newPassword, code)
      .then(() =>
        messageDialog("info", "Je wachtwoord is succesvol gereset. Je kunt nu inloggen.", ["OK"], () => {
          window.location.href = "/login"
        })
      )
      .catch((error: unknown) => {
        const reason = error instanceof EnkApiError ? error.description : "Onbekende fout!"
        console.error("Error resetting password:", error)
        setError("Er is een fout opgetreden bij het resetten van je wachtwoord. " + reason)
      })
  }

  return (
    <>
      {/*
              This example requires updating your template:
      
              ```
              <html class="h-full bg-gray-50">
              <body class="h-full">
              ```
            */}
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <EnkIwpLogo />
          </div>
          <div className="flex justify-center">
            <EnkHeader text="Wachtwoord opnieuw instellen" />
          </div>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && <div className="text-red-500 whitespace-pre-wrap">{error}</div>}
              <EnkInputField label="Nieuw Wachtwoord">
                <EnkInput type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
              </EnkInputField>
              <EnkInputField label="Bevestig Wachtwoord">
                <EnkInput type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
              </EnkInputField>
              <div className="flex justify-center">
                <EnkPrimaryButton text="Reset Wachtwoord" type="submit" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
